import React from "react";
import classes from './imageModal.module.scss';
import cx from 'classnames';
import CloseIcon from '@mui/icons-material/Close';

const MobileModalView = (props: any) => {
    const { itemData, imageModal, setImageModal } = props;

    return (
        <>
            <div className={classes.box}>
                {imageModal &&
                    <div className={classes.shadow} onClick={() => setImageModal(false)}>
                    </div>}
                <div className={cx(classes.emergancy, classes.emergancyMobile, imageModal ? classes.mobileListView : classes.mobileListHide)} >
                    <div className={classes.header}>
                        <span className={classes.title}>
                            <span className={classes.close}>
                                <CloseIcon onClick={() => setImageModal(!imageModal)} />
                            </span>
                            Images
                        </span>
                    </div>
                    <div className={classes.DisplayArea}>
                        {itemData?.map((node: any, idx: number) => {
                            return (

                                <div key={idx} className={classes.preview}>
                                    <img src={node.url} alt="pic" />
                                    <div className={classes.imageTitle}>{node?.displayName}</div>
                                </div>
                            )
                        })
                        }
                    </div>


                </div>
            </div>
        </>
    )
}

export default MobileModalView